module.exports = __webpack_public_path__ + "10fe6f5acd57fe735b47ff67b07d051c.svg";